import config from '../../config/theme-config.json' assert { type: 'json' };
//import Loader from "./modules/barba.js"; // keep
import Loader from "./modules/swup.js";

document.addEventListener('DOMContentLoaded', () => {

  // if ( config.features.loader ) {
  //   const loader = new Loader();
  //   loader.init();
  // }

  if ( config.features.swup ) {
    const loader = new Loader();
    loader.init();
  }

});
